export default "__VITE_ASSET__Ba2nX7P4__"